import { Component, OnInit, ViewEncapsulation} from '@angular/core';            //ViewEncapsulation :: 스타일 및 html 의 캡슐화
import { TranslateService } from '@ngx-translate/core';
import {CommonServices, GuideServices} from './shared/services/src/api';
import {PubSubService, RouterUtils, StorageUtils, StringUtils} from './shared/utils';
import { NavigationEnd, Router} from '@angular/router';
import { LanguageUtils } from './shared/utils/src/language.utils';
import { TeamServices} from './shared/services/src/api/team.services';
import { LocalStorageService} from 'angular-2-local-storage';
import {EnvServices, MsgPopupService} from './shared/services';
import { AppServices} from './shared/services';
import '../_asset/sources/assets/scripts/libs/jquery.marquee.min.js';
import * as _ from 'lodash';
import {LoginService} from './shared/services';
import {EnvUtils} from './shared/utils';
import {EnvLoadService} from './env-load/env-load.service';
import { environment } from '../environments/environment';
import {AuthServices} from './shared/authentications';
import {KeycloakloginService} from './shared/services';
import {IntegratedKeycloakloginService} from './shared/services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ '../_asset/sources/assets/styles/@scss/bsp.base.scss' ],
    encapsulation: ViewEncapsulation.None,
    providers: [ LoginService ]
})
export class AppComponent implements OnInit {
    loading = false;

    loginUser: any = {'id': '', 'name': ''};
    userLang = 'en';
    andebug = false;

    constructor(private translate: TranslateService,
                private _commonServices: CommonServices,
                private _pubsub: PubSubService,
                public router: Router,
                private teamServices: TeamServices,
                private localStorageService: LocalStorageService,
                private _appServices: AppServices,
                private _loginService: LoginService,
                private envServices: EnvServices,
                private envLoadService: EnvLoadService,
                private guideServices: GuideServices,
                private keycloakloginService: KeycloakloginService,
                private integratedKeycloakloginService: IntegratedKeycloakloginService,
                private _msgPopupService: MsgPopupService,
                private authService: AuthServices) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;

        if (this.andebug) {
            console.log('App Component Loading Start');
            console.log('         EnvCd : ', this.envLoadService.envCd);
            console.log('       SSO URL : ', this.envLoadService.ssoUrl);
            console.log('    Portal URL : ', this.envLoadService.portalUrl);
            console.log('    Notice URL : ', this.envLoadService.noticeUrl);
            console.log('   Chatbot URL : ', this.envLoadService.chatbotUrl);
            console.log('SupportUrl URL : ', this.envLoadService.supportUrl);
            console.log('   extnUrl URL : ', this.envLoadService.extnUrl);
            console.log('   notiUrl URL : ', this.envLoadService.notiUrl);
            console.log('  brandUrl URL : ', this.envLoadService.brandUrl);
            console.log(' opsNowUrl URL : ', environment.opsNowUrl);
            console.log('    apiUrl URL : ', environment.apiUrl);
        }

        // cookie 에 담을 domain 전역변수로 저장 SSO연결을 위한 도메인 split
        const subDomain: string[] = window.location.hostname.split('.');
        subDomain[0] = '';
        global['sub_domain'] = subDomain.join('.');

        const tokenKey = EnvUtils.envCdToTokenKey();
        const refreshKey = EnvUtils.envCdToRefreshKey();

        this.userLang = LanguageUtils.getLangCode();
        this.userLang = /(en|ko|zh|ja)/gi.test(this.userLang) ? this.userLang : 'en';
        translate.setDefaultLang(this.userLang);
        translate.use(this.userLang);

        this.integratedKeycloakStart(tokenKey, refreshKey);

        // 챗봇에서 사용하는 쿠키 생성(cc)
        // if ($.cookie('prev_cc')) {
        //     $.cookie('cc', $.cookie('prev_cc'), {domain: LanguageUtils.getSubDomain(), expires: 365, path: '/'});
        // } else {
        //     $.cookie('cc', StringUtils.getUuid(), {domain: LanguageUtils.getSubDomain(), expires: 365, path: '/'});
        // }
    }

    ngOnInit() {
    }

    keycloakStart(tokenKey) {
        this.keycloakloginService.init().then((keycloak) => {
            keycloak.onReady = () => {
                if (this.andebug) console.log('>>> keycloak.onReady');

                if (!this.keycloakloginService.isLoggedIn()) {
                    this.keycloakloginService.login();
                }
            };

            // 로그인 성공한 후 리다이렉트 될 경우 아래 이벤트 호출됨
            keycloak.onAuthSuccess = () => {
                if (this.andebug) console.log('>>> keycloak.onAuthSuccess: ', keycloak);
                if (this.andebug) console.log('>>> location.pathname: ', location.pathname);

                if (location.pathname === '/' || location.pathname === '/incident/incident') {
                    if (this.andebug) console.log('>>> 인시던트 화면 이동.');

                    const params = {
                        viewType : 'list'
                    };
                    RouterUtils.navigate(this.router, '/incident/incident/', params);
                }

                $.cookie(tokenKey, keycloak.token, {domain: global['sub_domain'], path: '/', expires: 365});
                this.getLoginUser();
            };

            keycloak.onAuthError = () => {
                console.log('Auth Error');
            };

            // 토큰이 만료될 경우 아래 로직 호출됨 (토큰 갱신)
            keycloak.onTokenExpired = () => {
                console.log('token expired');
                keycloak.updateToken(30).success(() => {
                    $.cookie(tokenKey, keycloak.token, {domain: global['sub_domain'], path: '/', expires: 365});
                    console.log('successfully get a new token');
                }).catch(() => {
                    console.error('Failed to refresh token');
                    this._pubsub.afterRequest.emit({status : 'token_expiration', body: 'afterRequestEvent'});
                });
            };
        });
    }

    getLoginUser() {
        if (this.andebug) console.log('>>> getLoginUser');

        this.loading = false;
        this._appServices.getSession()
            .then(async rslt => {
                this.loginUser = global['loginUser'];
                let curCmpnId = global['loginUser'].curCmpnId;

                if (this.loginUser.useConcurrent === 'true') {
                    const count = await this.keycloakloginService.getSessionCount();
                    console.log('login count: ', count);

                    if (count >= 2) {
                        // 중복 로그인 팝업
                        this._msgPopupService.msgEvent.emit({
                            'header_msg' : 'MK.01903',   // 중복된 계정 접속
                            'contents_msg' : 'MK.01904', // 다른 기기에서 동일한 계정으로 로그인이 시도되었습니다.<br> 로그아웃하고 현재 기기에서 다시 로그인 하시겠습니까?
                            'cancel_btn': 'MK.00048',
                            'close_btn_use_flag' : true
                        });
                    }
                }

                if (window.location.href.indexOf('curCmpnId') > -1) {
                    try {
                        // keycloak 인증 후 붙는 #state= 이후 제거.
                        const location_href = window.location.href.split('#state=')[0];
                        const option = JSON.parse(decodeURIComponent(decodeURIComponent(location_href.split('/').slice(-1)[0])));
                        curCmpnId = option.curCmpnId;
                    } catch (ex) {
                        console.log(ex);
                    }
                }

                this.trackGAData();

                global['loginUser'].curCmpnId = curCmpnId;
                this.guideServices.getGuideYn().then(result => {
                    if (result.status === 200) {
                        if (result.json().data.guide_yn === 'Y' && this.authService.isMenuAuthenticate('obj.guide')) {
                            RouterUtils.navigate(this.router, '/guide');
                        }
                    }
                });
            }).then(() => {
                const rolePrms = global['userRole'].rolePrms;
                const teamUse = _.find(rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_010', 'rsrcPathVal': 'obj.team.**'});
                global['teamUseYN'] = teamUse === undefined ? false : true;
                this.teamServices.setTeamUseBool(global['teamUseYN']);

                if (global['teamUseYN']) {
                    const _data = {
                        'type' : 'TT004',
                        'no' : '',
                        'teamNoUseYn' : 'N'
                    };

                    StorageUtils.setItem('alertNow.team', JSON.stringify(_data));
                } else {
                    StorageUtils.removeItem('alertNow.team');
                }

                this.updateUserTimezone();
            }).catch(error => {
                console.log(error);
            });
    }

    trackGAData() {
        window['dataLayer'].push({
            // user id to track individual
            'user_id' : this.loginUser.userId,
            // user id
            'crm_id' : this.loginUser.userEmail,
            // site name ex) BespinGlobal(OpsNow) or WL
            'site_name' : this.loginUser.siteCd,
            // user type ex) free or charge
            'user_type' : this.loginUser.chargeType,
            // user company ex) BespinGlobal, SendBird ...
            'user_company' : `${this.loginUser.blntCmpnNm}(${this.loginUser.blntCmpnId})`
        })
    }

    updateUserTimezone() {
        const prflTmznOfs = moment().utcOffset();
        const prflTmznOfsABS = Math.abs(prflTmznOfs);
        const hour = Math.floor(prflTmznOfsABS / 60);
        const minute = prflTmznOfsABS % 60;

        let prflTmznOfsStr = (hour < 10 ? '0' + hour.toString() : hour.toString()) +
            ':' +
            (minute < 10 ? '0' + minute.toString() : minute.toString());

        if (prflTmznOfs < 0) {
            prflTmznOfsStr = '-' + prflTmznOfsStr;
        } else {
            prflTmznOfsStr = '+' + prflTmznOfsStr;
        }

        const postData = {
            prflTmznCd: moment.tz.guess(),
            prflTmznOfs : prflTmznOfsStr
        };
        if (postData.prflTmznCd === 'Asia/Tokyo' && navigator.language.startsWith('ko')) {
            postData.prflTmznCd = 'Asia/Seoul';
        }

        this._commonServices.updateUserTimezone(postData).then((response: any) => {
        });

        this.loading = true;
    }

    integratedKeycloakStart(tokenKey, refreshKey) {
        this.integratedKeycloakloginService.init().then((keycloak) => {
            if (this.andebug) console.log('>>> Keycloak initialized');
            
            if (this.andebug) console.log(keycloak);
            keycloak.onReady = () => {
                if (this.andebug) console.log('>>> integratedkeycloak.onReady');

                if (!this.integratedKeycloakloginService.isLoggedIn()) {
                    if (this.andebug) console.log('>>> is not logged in');
                    this.integratedKeycloakloginService.login();
                }
            };

            // 로그인 성공한 후 리다이렉트 될 경우 아래 이벤트 호출됨
            keycloak.onAuthSuccess = () => {
                if (this.andebug) console.log('>>> keycloak.onAuthSuccess: ', keycloak);
                if (this.andebug) console.log('>>> location.pathname: ', location.pathname);

                if (location.pathname === '/' || location.pathname === '/incident/incident') {
                    if (this.andebug) console.log('>>> 인시던트 화면 이동.');

                    const params = {
                        viewType : 'list'
                    };
                    RouterUtils.navigate(this.router, '/incident/incident/', params);
                }

                $.cookie(tokenKey, keycloak.token, {domain: global['sub_domain'], path: '/', expires: 365});
                $.cookie(refreshKey, keycloak.refreshToken, {domain: global['sub_domain'], path: '/', expires: 365});
                this.getLoginUser();
            };

            keycloak.onAuthError = () => {
                console.log('Auth Error');
            };

            // 토큰이 만료될 경우 아래 로직 호출됨 (토큰 갱신)
            keycloak.onTokenExpired = () => {
                console.log('token expired');
                keycloak.updateToken(30).success(() => {
                    $.cookie(tokenKey, keycloak.token, {domain: global['sub_domain'], path: '/', expires: 365});
                    $.cookie(refreshKey, keycloak.refreshToken, {domain: global['sub_domain'], path: '/', expires: 365});
                    console.log('successfully get a new token');
                }).catch(() => {
                    console.error('Failed to refresh token');
                    this._pubsub.afterRequest.emit({status : 'token_expiration', body: 'afterRequestEvent'});
                });
            };
            if (this.andebug) console.log('>>> Keycloak init callback ended');
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts